import type { Data } from '@/api/api.ts'
import type {
  AuthPhoneNumberRequestData,
  ClientPhoneNumberRequestData,
  LoginRequestData,
} from '@/types/authentication.types'
import axios from 'axios'
import { baseUrl } from '@/constants/api'

const urlPrefix = `${baseUrl}user/phone-confirm/incoming-call/`

export const getPhoneDst = async (country: string): Promise<Data<AuthPhoneNumberRequestData>> => {
  return axios.get(`${urlPrefix}phonedst/`, {
    params: { country },
  })
}

export const checkStatus = async (country: string): Promise<Data<ClientPhoneNumberRequestData>> => {
  return axios.get(`${urlPrefix}phonesrc/`, { params: { country } })
}

export const reconfirm = async (country: string): Promise<Data<LoginRequestData>> => {
  return axios.post(`${urlPrefix}reconfirm/`, { country })
}
